

















import { defineComponent } from '@nuxtjs/composition-api'
import NavigationLink from '@/components/Navigation/NavigaitionLink.vue'

export default defineComponent({
  name: 'NavigationSectionSubpageSelect',
  components: { NavigationLink },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    layout: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: 0,
    },
    image: {
      type: Object,
      default: () => {},
    },
    divider: {
      type: Boolean,
      default: false,
    },
    svgIcon: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('input', props.id)
    }
    return {
      onClick,
    }
  },
})
